import { identifierModuleUrl } from '@angular/compiler';

export class BatchCalls {
  public id: number;
  public batch_type_id: number;
  public call_type_id: number;
  public status_id: number;
}
